
import { func } from 'prop-types';
import * as types from '../actiontypes';

export function setUnsavedDataModalState(region, value) {
	return {
		type: types.SET_UNSAVED_DATA,
		region: region,
        value: value
	};
}

export function clearUnsavedDataState() {
    return {
        type: types.CLEAR_UNSAVED_DATA_STATE
    }
}